module.exports = __webpack_public_path__ + "img/banner_logo_rule.cb74532d.png";